// src/api/user.api.js
import apiClient from './apiClient';

/**
 * Fetches the profile of the currently logged-in user.
 */
export const getMyProfile = async () => {
    const response = await apiClient.get('/users/me');
    return response.data;
};

/**
 * Updates the profile of the currently logged-in user.
 * @param {object} profileData - The data to update.
 */
export const updateMyProfile = async (profileData) => {
    const response = await apiClient.put('/users/me', profileData);
    return response.data;
};

/**
 * Fetches the detailed learning progress for the current user.
 */
export const getMyProgress = async () => {
    const response = await apiClient.get('/learning/progress');
    return response.data;
};

/**
 * Fetches the gamification profile (level, XP, etc.) for the current user.
 */
export const getMyGamificationProfile = async () => {
    const response = await apiClient.get('/gamification/profile');
    return response.data;
};

/**
 * Fetches the badges earned by the current user.
 */
export const getMyBadges = async () => {
    const response = await apiClient.get('/gamification/badges/earned');
    return response.data;
};

/**
 * Fetches the skills profile for the current user.
 */
export const getMySkills = async () => {
    const response = await apiClient.get('/gamification/skills');
    return response.data;
};

export const getCurrentUser = async () => {
    try {
        // This endpoint should be protected on the backend and return the user
        // based on the JWT token provided in the Authorization header.
        const response = await apiClient.get('/users/me');
        return response.data;
    } catch (error) {
        console.error("Could not fetch current user:", error);
        return null;
    }
};

export const getDashboardData = async () => {
    const response = await apiClient.get('/users/me/dashboard');
    return response.data;
};

/**
 * Generate Ghibli-style avatar from uploaded image
 * @param {File} imageFile - The image file to transform
 * @returns {Promise} Avatar generation response
 */
export const generateAvatar = async (imageFile) => {
    try {
        const formData = new FormData();
        formData.append('image', imageFile);

        const response = await apiClient.post('/users/generate-avatar', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            timeout: 300000, // 5 minutes timeout for AI processing
        });

        return response.data;
    } catch (error) {
        console.error('Avatar generation error:', error);
        throw error;
    }
};

/**
 * Update user avatar URL
 * @param {string} avatarUrl - The new avatar URL
 * @returns {Promise} Update response
 */
export const updateAvatar = async (avatarUrl) => {
    try {
        const response = await apiClient.put('/users/me', {
            avatar_url: avatarUrl
        });
        return response.data;
    } catch (error) {
        console.error('Avatar update error:', error);
        throw error;
    }
};